import config from "app/config"

export const getGroupInviteUrl = (id: string, inviteToken?: string) => {
  const groupBaseUrl = `${config.siteUrl}/groups`
  const groupUrl = inviteToken ? `${groupBaseUrl}/invite/${inviteToken}` : `${groupBaseUrl}/${id}`
  return groupUrl
}
